
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14.5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.576 10L6.84 7.664c-.304-.41-.667-.91-1.088-1.496l-.016.008c.01.736.016 1.293.016 1.672V10H4.528V4.208h1.2l1.736 2.336c.304.41.667.91 1.088 1.496l.016-.008c-.01-.736-.016-1.293-.016-1.672V4.208h1.224V10h-1.2z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.071 0A7.07 7.07 0 000 7.071 7.07 7.07 0 107.071 0zm4.125 11.197a5.81 5.81 0 01-4.125 1.708 5.81 5.81 0 01-4.125-1.708 5.81 5.81 0 01-1.709-4.125 5.81 5.81 0 011.709-4.125 5.81 5.81 0 014.125-1.709 5.81 5.81 0 014.125 1.709 5.81 5.81 0 011.709 4.125 5.81 5.81 0 01-1.709 4.125z","fill":"currentColor"}})])
          )
        }
      }
    